import { Theme } from '@wds/styles';
import { createUseStyles } from 'react-jss';

const useMobileMenuStyles = createUseStyles(
  ({ palette, spacing, type }: Theme) => ({
    MobileMenuAnon: {
      '& .sm-mobile-menu-anon__anchor': {
        '&:hover, &:focus': {
          textDecoration: 'none',
        }
      },

      '& .sm-mobile-menu-anon__link': {
        textDecoration: 'none',
        outline: 0,
        color: palette.text.dark,
      },

      '& .sm-mobile-menu-anon__type-title': {
        margin: [spacing[4], 0],
        fontSize: type.fontSize.body,
        fontWeight: type.fontWeight.medium,

        '&:hover, &:focus': {
          textDecoration: 'none',
        },

        '& .sm-mobile-menu-anon--no-subtitle': {
          fontWeight: type.fontWeight.regular,
        },

        '& .sm-mobile-menu-anon--has-arrow-icon': {
          fontSize: type.fontSize.body,
          fontWeight: type.fontWeight.medium,
        },

        '& .sm-mobile-menu-anon__arrow-icon': {
          position: 'relative',
          marginLeft: spacing[2],
          top: 2,
        }
      },

      '& .sm-mobile-menu-anon__type-subtitle': {
        margin: [spacing[1], 0, 0, 0],
        fontSize: 13,
        fontWeight: type.fontWeight.regular,
        color: palette.text.darkMuted,
      },

      '& .sm-mobile-menu-anon__cta': {
        width: `calc(100% - ${spacing[8]}px)`,
        margin: [spacing[5], spacing[6]],
        outline: 0,
      }
    },

  })
);

export default useMobileMenuStyles;
